import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
export const ProductMedia = ({ product, eager = false, caption = false, className }) => {
    const { t } = useTranslation();
    if (!product.image)
        return null;
    return (_jsxs(Media, { className: className, children: [_jsx("img", { src: product.image, width: 720, height: 720, alt: t('home.showcase.imageAlt', { product: t(product.nameKey) }), loading: eager ? 'eager' : 'lazy', decoding: "async" }), caption && (_jsx("figcaption", { children: product.category === 'software'
                    ? t('home.showcase.softwareCaption')
                    : t('home.showcase.illustrations') }))] }));
};
const Media = styled.figure `
  width: 100%;
  max-width: 480px;
  margin: 0;
  img {
    display: block;
    width: 100%;
    height: auto;
    aspect-ratio: 4 / 3;
    object-fit: cover;
    object-position: center;
  }
  figcaption {
    margin-top: 0.75rem;
    color: ${({ theme }) => theme.colors.muted};
    font-size: 0.75rem;
    line-height: 1.6;
  }
`;
